import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td} from "@chakra-ui/react";
import { TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useMemo} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom,modalAtom } from "../../../context";
import { NewLoader as Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { MdMoreVert as MoreIcon } from "react-icons/md"
import moment from "moment";
import {
  Grid,
  GridItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from '@chakra-ui/react'

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function RegistrationReport({ data }:any)  {
const [hide,set_hide] = useState<boolean>(true);
const queryClient = useQueryClient();
const [activeIndex] = useAtom(indexAtom);
const [,set_open] = useAtom(openAtom);
const [,set_Nopen] = useAtom(openNAtom);
const [,set_notification]= useAtom(notificationAtom);
const [selected_examperiod,set_selected_examperiod] = useState<any>('');
const [selected_level,set_selected_level] = useState<null | string>(null);
const [selected_subject, set_selected_subject] = useState<null | string>(null);

const setType = useMemo(() => ['Both', 'Resit', 'Regular'], []);
 



const handleRequest =(level:number | null,period:null|number)=>{
  return level&&period
  
}
 
const {data:allExamPeriod} = useQuery(['exam-period'],{
      queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
      select(data){
       
        return data.data.Data;
      },
    });
  
    const {data:allLevel} = useQuery(['exemption'],{
      queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
      select(data){
        return data.data.Data;
      },
    })

  const [search, set_search] = useState('');
  const [debounced_search, set_debounced_search] = useState('');
  const itemsPerPage = 100;
  const [pageNumber, set_pageNumber] = useState(1);

  // Debounce the search box so we don't fire a request on every keystroke.
  useEffect(() => {
    const timer = setTimeout(() => set_debounced_search(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search]);

  // Any change to filters/search invalidates the current page.
  useEffect(() => {
    set_pageNumber(1);
  }, [selected_examperiod, selected_level, selected_subject, debounced_search]);

  const examPeriodIdByName = useMemo(() => {
    const map = new Map<string, any>();
    (allExamPeriod || []).forEach((p: any) => map.set(p.ExamName, p.Id));
    return map;
  }, [allExamPeriod]);

  const selectedPeriodName = useMemo(() => {
    if (!selected_examperiod) return null;
    return (allExamPeriod || []).find((p: any) => String(p.Id) === String(selected_examperiod))?.ExamName ?? null;
  }, [allExamPeriod, selected_examperiod]);

  // One request per page, always - server applies PageNumber/PageSize plus
  // whichever filters are active. ExamPeriodId/LevelId aren't 100% reliably
  // honored by this endpoint, so as a cheap (no extra request) safety net we
  // also re-check the real Level.Id/ExamPeriod fields on just the page that
  // came back, instead of pre-fetching every page up front.
  const { data: pagedResult, isLoading } = useQuery(
    ['registration-report-page', selected_examperiod, selected_level, selected_subject, debounced_search, pageNumber],
    async () => {
      const params: Record<string, any> = {
        PageNumber: pageNumber,
        PageSize: itemsPerPage,
      };
      if (selected_examperiod) params.ExamPeriodId = selected_examperiod;
      if (selected_level) params.LevelId = selected_level;
      if (selected_subject) params.ResitPrompt = selected_subject;
      if (debounced_search) params.StudentNo = debounced_search;

      const response = await apiCall().get(`Exam/GetAllRegisteredStudent`, { params });
      return response.data;
    },
    {
      keepPreviousData: true,
      select(data: any) {
        let items = data?.reportItems || [];
        if (selected_level) items = items.filter((d: any) => String(d.Level?.Id) === String(selected_level));
        if (selectedPeriodName) items = items.filter((d: any) => d.ExamPeriod === selectedPeriodName);
        const totalCount = data?.TotalCount ?? items.length;
        return {
          items,
          totalCount,
          pageCount: data?.PageCount ?? Math.max(1, Math.ceil(totalCount / itemsPerPage)),
        };
      },
    }
  );

  const currentItems = pagedResult?.items || [];
  const totalCount = pagedResult?.totalCount ?? 0;
  const pageCount = pagedResult?.pageCount ?? 1;
  const itemOffset = (pageNumber - 1) * itemsPerPage;
  const endOffset = Math.min(itemOffset + itemsPerPage, totalCount);

  const handlePageClick = (event: any) => {
    set_pageNumber(event.selected + 1);
  };

  const handleReload = () => {
    set_search('');
    set_pageNumber(1);
  };


  const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
    mutationKey: [selected_examperiod, selected_level],
    mutationFn: async () => {
      let url = `/ExamReport/downloadAllRegisteredStudentReport`;
  
      const params = new URLSearchParams();
      if (selected_examperiod) params.append("ExamPeriodId", selected_examperiod);
      if (selected_level) params.append("LevelId", selected_level);
      if (selected_subject) params.append("ResitPrompt", selected_subject);

  
      // If any parameters were added, append them to the URL
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
  
      const method = "POST", body = {}, config = {}, download = true;
      return await downloadApi(url, method, body, config, download);
    },
    onSuccess: async (data: any) => {
      // Initialize the download
      console.log(data, 'download data');
      const file = data;
  
      if (file) {
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Registered Candidate-List.xlsx");
        document.body.appendChild(link);
        link.click();
        console.log(file, 'data');
        set_notification({
          type: 'success',
          message: data?.data?.Message || 'Registered Candidate List downloaded successfully'
        });
        set_Nopen(true);
      } else {
        set_notification({
          type: 'error',
          message: 'Oops! An error occurred while trying to download the file'
        });
        set_Nopen(true);
      }
    },
    onError(error: any) {
      set_notification({ 
        type: 'error',
        message: error?.data?.Message || 'An error occurred'
      });
      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    }
  });

  return (
    <>
      <Box>
      <TopDisplay label="Registered Candidate List" button_array={[
        
          <Button disabled={isDownloading} type="submit" color="var(--white-color)" 
          bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
          onClick={()=>handleDownload()} 
        > {isDownloading?"DownLoading":'Download Registered Candidate List'}</Button>,
         
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
          
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={(e: any) => set_search(e.target.value)} type='text' placeholder='search' />
          <span
            style={{
              position: 'absolute',
              zIndex: '1',
              right: '10px',
              cursor: 'pointer',
              top: '12px'
            }}
            onClick={handleReload} 
          >
            <ReloadIcon />
          </span>
          </InputGroup>

          <Select 
              placeholder='Exam Period' 
              width="140px" 
              bg="var(--white-color)" 
              borderColor="var(--dark-green-color)" 
              onChange={(e: any) => set_selected_examperiod(e.target.value)}
              name="ExamPeriodId"
              >
              <option value="">All Exam Periods</option> 

              {allExamPeriod && allExamPeriod.length > 0 ? 
                allExamPeriod.map((eType: any) => (
                  <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>
                )) 
              : ''}
            </Select>

              <Select placeholder="Level" width="140px" bg="var(--white-color)"
              borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_level(e.target.value || null)} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
             <Select placeholder='Re-Sit Type' width="140px" bg="var(--white-color)"
              borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_subject(e.target.value || null)}
                  name="SitType"
                >
                  <>{setType.map((eType:any) => <option key={eType} value={eType}>{eType}</option>)}</>
                </Select>
          </Flex>

        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Registered Candidate</Heading>
          <Text m="0" fontSize=".8rem">Showing {totalCount === 0 ? 0 : itemOffset + 1} - {endOffset} of {totalCount}</Text>
        </Flex>
        {  currentItems && currentItems.length > 0 ?  <TableContainer mt="20px">
          <Table size="sm" variant="striped" sx={{ tableLayout: 'auto', width: '100%' }}>
      <Thead>
      <Tr>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Student Number</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>First Name</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Last Names</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Gender</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Phone No</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Email</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Subject</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>study center</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Level</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Exam Diet</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Address</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Amount</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Reg.Date</Th>
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam Date</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Resit</Th>
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Deffered</Th> */}
        {/* <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam Status</Th> */}
        <Th sx={{ ...HeadStyle, p: 2, minWidth: '50px' }}></Th>
      </Tr>
    </Thead>
    <Tbody>
      {currentItems.map((eUpgradeScore: any, index: number) => (
        <ROWSTYLE key={eUpgradeScore.Id}>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.StudentNo || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.FirstName || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2, whiteSpace: 'normal' }}>{eUpgradeScore.LastName || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Gender || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.PhoneNumber || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Email || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore?.Subjects?.map((eSubject: any) => eSubject.ExamSubject.Name)?.join(', ')?.slice(0, 35) || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore?.StudyCenter?.Name || 'N/A'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Level?.ExemptionName || ''}</Td>
          {/* <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Level?.ExamDiet || ''}</Td> */}
          <Td title={eUpgradeScore.Address} sx={{ ...DataStyle, p: 2, whiteSpace: 'normal', maxWidth: '180px' }}>
            {eUpgradeScore.Address || 'N/A'}
          </Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore?.Level?.ExamAmount ?? 'N/A'}
            </Td>
        <Td sx={{ ...DataStyle, p: 2 }}>
         {moment.utc(eUpgradeScore.RegistrationDate).local().format("YYYY-MM-DD hh:mm:ss A")}
        </Td>

          {/* <Td sx={{ ...DataStyle, p: 2 }}>{moment(eUpgradeScore.ExamDateTime).format("yyyy-MM-DD")}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.IsResit ? 'Yes' : 'No'}</Td>
          <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.IsDeffered ? 'Yes' : 'No'}</Td> */}
          <Td sx={{ ...DataStyle, p: 2 }} minW="60px" w="50px" h="50px">
            <Option
              index={index}
              candidate={{ ...eUpgradeScore, ExamPeriodId: examPeriodIdByName.get(eUpgradeScore.ExamPeriod) }}
              levels={allLevel}
              periods={allExamPeriod}
            />
          </Td>
        </ROWSTYLE>
     ))}
    </Tbody>
  </Table>
</TableContainer>
: 'No Registered Candidate'}

      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
    <Loader show={isLoading} />

</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
  const queryClient = useQueryClient();

  useEffect(()=>{
    set_new_level(candidate?.Level?.Id)
  },[])

 

  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

 
  
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>
            View Details
          </GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  const img = "/public-assets/profile.png";
  return(
  <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
    <Grid templateColumns="1fr"  gap="30px">
      
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Student No</Text>
        <Text fontWeight="500">{props.candidate?.StudentNo}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">First Name</Text>
        <Text fontWeight="500">
          {props.candidate.FirstName}
        </Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Last Name</Text>
        <Text fontWeight="500">{props.candidate?.LastName}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Phone</Text>
        <Text fontWeight="500">{props.candidate?.PhoneNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Email</Text>
        <Text fontWeight="500">{props.candidate?.Email}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Level</Text>
        <Text fontWeight="500">{props.candidate?.Level?.ExemptionName }</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Amount</Text>
        <Text fontWeight="500">{props.candidate?.Amount}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Address</Text>
        <Text fontWeight="500">{props.candidate?.Address}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Registration Date</Text>
        <Text fontWeight="500">{moment(props.candidate?.RegistrationDate).format("yyyy-MM-DD")}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Exam Date</Text>
        <Text fontWeight="500">{moment(props.candidate?.ExamDateTime).format("yyyy-MM-DD")}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Resit</Text>
        <Text fontWeight="500">{props.candidate?.IsResit ? 'Yes' : 'No'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Subjects</Text>
        <Text fontWeight="500">
          {props.candidate.Subjects.map((eSubject: any) => eSubject.ExamSubject.Name).join(', ')}
        </Text>
      </GridItem>
      
    </Grid>
  </Flex>
  )}
